import {
  AnalysisMethod,
  AnalysisSetWithCondition,
  DataSubsetWithCondition,
  GroupingFactorWithGroups,
  GroupWithCondition,
} from "../ars_ldm";
import { CURRENT_HIERARCHY_ID } from "./interface";

/**
 * Creates a new AnalysisMethod with default values.
 *
 * @param name - The name for the new analysis method
 * @returns A new AnalysisMethod with an empty operations list and code template
 */
export const createNewAnalysisMethod = (name: string): AnalysisMethod => ({
  id: crypto.randomUUID(),
  name,
  operations: [],
  codeTemplate: {
    context: "",
    code: "",
  },
  fromHierarchyId: CURRENT_HIERARCHY_ID,
});

/**
 * Creates a new AnalysisSet with default values and an empty condition.
 *
 * @param name - The name for the new analysis set
 * @returns A new AnalysisSetWithCondition with level and order set to 0
 */
export const createNewAnalysisSet = (name: string): AnalysisSetWithCondition => ({
  id: crypto.randomUUID(),
  name,
  level: 0,
  order: 0,
  condition: {
    dataset: "",
    variable: "",
  },
  fromHierarchyId: CURRENT_HIERARCHY_ID,
});

/**
 * Creates a new DataSubset with default values and an empty condition.
 *
 * @param name - The name for the new data subset
 * @returns A new DataSubsetWithCondition with level and order set to 0
 */
export const createNewDataSubset = (name: string): DataSubsetWithCondition => ({
  id: crypto.randomUUID(),
  name,
  level: 0,
  order: 0,
  condition: {
    dataset: "",
    variable: "",
  },
  fromHierarchyId: CURRENT_HIERARCHY_ID,
});

/**
 * Creates a new GroupingFactor with default values and an empty groups list.
 *
 * @param name - The name for the new grouping factor
 * @returns A new GroupingFactorWithGroups with dataDriven set to false and no groups
 */
export const createNewGroupingFactor = (name: string): GroupingFactorWithGroups => ({
  id: crypto.randomUUID(),
  name,
  dataDriven: false,
  groups: [],
  fromHierarchyId: CURRENT_HIERARCHY_ID,
});

/**
 * Creates a new Group with default values and an empty condition.
 *
 * @param name - The name for the new group
 * @param order - The order for the new group
 * @returns A new GroupWithCondition with default values and an empty condition
 */
export const createNewGroup = (name: string, order: number): GroupWithCondition => ({
  id: crypto.randomUUID(),
  name,
  label: name,
  description: "",
  condition: {},
  level: 0,
  order,
});
